import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

const NewQuotePage = lazy(() =>
  import('../../../pages').then((module) => ({ default: module.NewQuotePage }))
);
const SavedQuotesPage = lazy(() =>
  import('../../../pages').then((module) => ({
    default: module.SavedQuotesPage,
  }))
);

export const quotationChildrenRoutes = [
  {
    path: '',
    element: <Navigate to={'nueva-cotizacion'} />,
  },
  {
    path: 'nueva-cotizacion',
    element: <NewQuotePage />,
  },
  {
    path: 'nueva-cotizacion/:quotation',
    element: <NewQuotePage />,
  },
  {
    path: 'renovar-cotizacion/:quotation',
    element: <NewQuotePage />,
  },
  {
    path: 'cotizaciones-guardadas',
    element: <SavedQuotesPage />,
  },
];
